import React, { useState } from "react";
import { PlayerAvatarContainer } from "./GameTimeline.styles";
import { FallbackSoccerAvatarMaleIcon } from "@icons/FallbackSoccerAvatarMaleIcon";
import { PlayerIcon } from "./GamePlayerIcon.styles";

export function GamePlayerIcon({
    playerData,
}: {
    playerData: { id: string | undefined; imageUrl: string | undefined };
}) {
    const [error, setError] = useState(!playerData.imageUrl);
    return (
        <PlayerAvatarContainer>
            {error ? (
                <FallbackSoccerAvatarMaleIcon
                    width={"100%"}
                    height={"100%"}
                    fill={"var(--community-color-light-steal-blue)"}
                />
            ) : (
                <PlayerIcon
                    src={playerData.imageUrl}
                    onError={() => setError(true)}
                />
            )}
        </PlayerAvatarContainer>
    );
}
